import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Icon from "components/AppIcon";

import MetricCard from "./components/MetricCard";
import AlertsSection from "./components/AlertsSection";
import UpcomingExpirations from "./components/UpcomingExpirations";
import SubscriptionChart from "./components/SubscriptionChart";
//lang
import { useLanguage } from "../../LanguageContext";
import { getStatisticsService } from "redux/services/general_service";
import { useDispatch, useSelector } from "react-redux";

const DashboardOverview = () => {


  const { language } = useLanguage();

  const {statistics ,notifications} = useSelector((state)=>state.general)

  const navigate = useNavigate();

  const dispatch = useDispatch()

  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);

  const isRTL = language === "ar";

  // Mock data
  const dashboardData = {
    metrics: {
      totalActiveClients: 245,
      subscriptionsEndingSoon: 18,
      expiredSubscriptions: 7,
      newRegistrations: 12,
    },
    alerts: [
      {
        id: 1,
        clientName: "Ahmed Al-Rashid",
        type: "ending_soon",
        daysRemaining: 3,
        subscriptionEnd: "2024-01-15",
      },
      {
        id: 2,
        clientName: "Sarah Johnson",
        type: "expired",
        daysOverdue: 2,
        subscriptionEnd: "2024-01-10",
      },
      {
        id: 3,
        clientName: "Mohammed Hassan",
        type: "ending_soon",
        daysRemaining: 5,
        subscriptionEnd: "2024-01-17",
      },
    ],
    upcomingExpirations: [
      { id: 1, name: "Ahmed Al-Rashid", daysLeft: 3, endDate: "2024-01-15" },
      { id: 2, name: "Mohammed Hassan", daysLeft: 5, endDate: "2024-01-17" },
      { id: 3, name: "Fatima Al-Zahra", daysLeft: 7, endDate: "2024-01-19" },
      { id: 4, name: "Omar Abdullah", daysLeft: 10, endDate: "2024-01-22" },
      { id: 5, name: "Layla Ibrahim", daysLeft: 12, endDate: "2024-01-24" },
    ],
    chartData: [
      { month: "Jan", active: 220, new: 15, expired: 5 },
      { month: "Feb", active: 235, new: 20, expired: 8 },
      { month: "Mar", active: 245, new: 18, expired: 7 },
      { month: "Apr", active: 250, new: 12, expired: 6 },
      { month: "May", active: 245, new: 10, expired: 9 },
      { month: "Jun", active: 255, new: 16, expired: 4 },
    ],
  };

  useEffect(()=>{
    dispatch(getStatisticsService())
  },[])

  const translations = {
    en: {
      title: "FitAdmin Pro",
      dashboard: "Dashboard Overview",
      clientManagement: "Client Management",
      addEditClient: "Add/Edit Client",
      subscriptionManagement: "Subscription Management",
      adminAccounts: "Admin Accounts",
      logout: "Logout",
      searchPlaceholder: "Search clients...",
      totalActiveClients: "Total Active Clients",
      subscriptionsEndingSoon: "Subscriptions Ending Soon",
      expiredSubscriptions: "Expired Subscriptions",
      newRegistrations: "New Registrations This Month",
      alertsRequiringAttention: "Alerts Requiring Attention",
      upcomingExpirations: "Upcoming Subscription Expirations",
      subscriptionTrends: "Subscription Trends",
      addNewClient: "Add New Client",
      sendNotifications: "Send Notifications",
      viewAll: "View All",
      renewSubscription: "Renew",
      daysLeft: "days left",
      expired: "Expired",
      endingSoon: "Ending Soon",
      profile: "Profile",
      settings: "Settings",
    },
    ar: {
      title: "فيت أدمن برو",
      dashboard: "نظرة عامة على لوحة التحكم",
      clientManagement: "إدارة العملاء",
      addEditClient: "إضافة/تعديل عميل",
      subscriptionManagement: "إدارة الاشتراكات",
      adminAccounts: "حسابات المدراء",
      logout: "تسجيل الخروج",
      searchPlaceholder: "البحث عن العملاء...",
      totalActiveClients: "إجمالي العملاء النشطين",
      subscriptionsEndingSoon: "الاشتراكات المنتهية قريباً",
      expiredSubscriptions: "الاشتراكات المنتهية",
      newRegistrations: "التسجيلات الجديدة هذا الشهر",
      alertsRequiringAttention: "التنبيهات التي تتطلب انتباه",
      upcomingExpirations: "انتهاء الاشتراكات القادمة",
      subscriptionTrends: "اتجاهات الاشتراك",
      addNewClient: "إضافة عميل جديد",
      sendNotifications: "إرسال الإشعارات",
      viewAll: "عرض الكل",
      renewSubscription: "تجديد",
      daysLeft: "يوم متبقي",
      expired: "منتهي",
      endingSoon: "ينتهي قريباً",
      profile: "الملف الشخصي",
      settings: "الإعدادات",
    },
  };

  const t = translations[language];



  const handleNavigation = (path) => {
    navigate(path);
  };

  const handleLogout = () => {
    navigate("/admin-login");
  };

  const toggleLanguage = () => {
    setLanguage((prev) => (prev === "en" ? "ar" : "en"));
  };

  return (
    <div className={`min-h-screen bg-gray-50 ${isRTL ? "rtl" : "ltr"}`}>
      <div className="flex pt-16">
        <div className="p-6">
     
          <div className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-2">
              {t.dashboard}
            </h2>
        
          </div>

          {/* Metrics Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
            <MetricCard
              title={t.totalActiveClients}
              value={statistics?.active_clients}
              icon="Users"
              color="green"
            //  trend="+5.2%"
            />
            <MetricCard
              title={t.subscriptionsEndingSoon}
              value={statistics?.end_soon_clients}
              icon="AlertTriangle"
              color="yellow"
            //  trend="+2"
            />
            <MetricCard
              title={t.expiredSubscriptions}
               value={statistics?.inactive_clients}
          
              icon="XCircle"
              color="red"
            //  trend="-3"
            />
            <MetricCard
              title={t.newRegistrations}
              value={statistics?.new_clients}
              icon="UserPlus"
              color="blue"
             // trend="+8"
            />
          </div>

          {/* Quick Actions */}
          <div className="flex flex-wrap gap-4 mb-8">
            <button
              onClick={() => navigate("/add-edit-client-profile")}
              className="bg-green-600 text-white px-6 py-3 rounded-lg hover:bg-green-700 transition-colors flex items-center gap-2"
            >
              <Icon name="UserPlus" size={20} />
              {t.addNewClient}
            </button>
           {/* <button className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors flex items-center gap-2">
              <Icon name="Bell" size={20} />
              {t.sendNotifications}
            </button>*/}
          </div>

          <div className="grid grid-cols-1 xl:grid-cols-3 gap-8">
            {/* Left Column - Alerts and Chart */}
            <div className="xl:col-span-2 space-y-8">
              <AlertsSection
                alerts={notifications}
                title={t.alertsRequiringAttention}
                translations={t}
              />
             {/* <SubscriptionChart
                data={dashboardData.chartData}
                title={t.subscriptionTrends}
              />*/}
            </div>

            {/* Right Column - Upcoming Expirations */}
           {/* <div className="xl:col-span-1">
              <UpcomingExpirations
                expirations={dashboardData.upcomingExpirations}
                title={t.upcomingExpirations}
                translations={t}
              />
            </div>*/}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardOverview;
